module.exports = __webpack_public_path__ + "static/img/年度最佳折叠屏手机.98670d56.png";